var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { MemberSearchService } from './member_search.service';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
var MemberSearchConditionComponent = /** @class */ (function (_super) {
    __extends(MemberSearchConditionComponent, _super);
    function MemberSearchConditionComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.condList = [];
        return _this;
    }
    MemberSearchConditionComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    MemberSearchConditionComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    MemberSearchConditionComponent.prototype.onSubscribe = function (data) {
        this.condList = [];
        if (typeof data !== 'undefined' && typeof data.dispSearchConditionList !== 'undefined') {
            this.condList = data.dispSearchConditionList;
        }
    };
    MemberSearchConditionComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    MemberSearchConditionComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'membersearch-condition',
                    template: "<div class=\"andOrStatus\">\n  <div *ngIf=\"condList.length <= 0\">\n    <div class=\"andOrStatus_status\">\n      <p class=\"andOrStatus_status_ttl\">{{ (msg | async)['MemberSearchComponent.searchCondition.noResult'] }}</p>\n    </div>\n  </div>\n  <div *ngFor=\"let cond of condList; let index = index;\">\n    <membersearch-conditiongroup [cond]=\"cond\" [index]=\"index\"></membersearch-conditiongroup>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    MemberSearchConditionComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: MemberSearchService }
    ]; };
    return MemberSearchConditionComponent;
}(ContentBaseComponent));
export { MemberSearchConditionComponent };
//# sourceMappingURL=condition.component.js.map